export const parseCurrency = (value?: string): number => {
  if (!value) return 0;

  const sanitized = value.replace(/[^\d.,]/g, '');

  // EU format: 25,00
  if (sanitized.includes(',') && !sanitized.includes('.')) {
    return Number(sanitized.replace(',', '.'));
  }

  // EN format: 25.00
  if (sanitized.includes('.')) {
    return Number(sanitized);
  }

  return Number(sanitized);
};